import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const GET_KEYWORD_STATS_DATA = `${API_URL}/api/v1/parent/keystroke-alert1`;
export const DELETE_KEYWORD_STATS = `${API_URL}/api/v1/parent/delete-activity`;

export function getKeyWordStatsData(payload) {
  return axiosInstance({
    url: GET_KEYWORD_STATS_DATA,
    method: "GET",
    params: payload,
  });
}

export function deleteKeywordStats(payload) {
  return axiosInstance({
    url: DELETE_KEYWORD_STATS,
    method: "POST",
    data: payload,
  });
}
